// extracted by mini-css-extract-plugin
export var discard = "_4m-3";
export var muiTooltipTooltip = "_4m-5";
export var notificationBar = "_4m-2";
export var saveButtonHoverSlotWrapper = "_4m-4";
export var show = "_4m-1";
export var spacer = "_4m-0";